import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { injectIntl } from 'react-intl'
import { Game } from '../../../Core'

import * as selectors from '../quizzes.selectors'
import * as actions from '../quizzes.actions'
import * as indicatorsSelectors from '../../Indicators/indicators.selectors'
import * as audioActions from '../../../Core/Game/AudioContainer/audio.actions'

import AnswerQuestion from './AnswerQuestion'

const mapDispatchToProps = (dispatch) => ({
  answerQuestion: bindActionCreators(actions.answerQuestion, dispatch),
  clearResponses: bindActionCreators(actions.clearResponses, dispatch),
  clearFeedBack: bindActionCreators(actions.clearFeedBack, dispatch),
  likeQuestion: bindActionCreators(actions.likeQuestion, dispatch),
  removeQuestion: bindActionCreators(actions.setQuestion, dispatch),
  endFlow: bindActionCreators(actions.endFlow, dispatch),
  addPopup: bindActionCreators(Game.actions.addPopup, dispatch),
  addHowlSound: bindActionCreators(audioActions.playHowlAudio, dispatch),
})

const mapStateToProps = (state) => ({
  error: selectors.isSavedError(state),
  currentQuestion: selectors.getCurrentQuestion(state),
  feedback: selectors.getFeedBack(state),
  loading: selectors.getLoading(state),
  prizeCoins: selectors.getAnswerPrizeCoins(state),
  isPenalized: selectors.isAnswerPenalized(state),
  counters: indicatorsSelectors.getCountersData(state),
})

export default connect(mapStateToProps, mapDispatchToProps)(injectIntl(AnswerQuestion))
